import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NewsFeedComponent } from "./news-feed.component";
import { IonicModule } from "@ionic/angular";
import { IsNewsLikedByMeModule } from "src/app/pipes/is-news-liked-by-me/is-news-liked-by-me.module";
import { GetNewsImageModule } from "src/app/pipes/get-news-image/get-news-image.module";
import { RouterModule } from "@angular/router";

@NgModule({
  imports: [CommonModule, IonicModule, RouterModule, IsNewsLikedByMeModule, GetNewsImageModule],
  declarations: [NewsFeedComponent],
  exports: [NewsFeedComponent],
})
export class NewsFeedModule {}
